import CheckboxV2 from './CheckboxV2';
export default CheckboxV2;
